import { ISearchPage, ICmSearchPageFields } from "../../../types/FmsTypes";

export enum OptType {
    ADD_ROOT = 1,//跟
    ADD_SAME_LEVEL = 2,//同级
    ADD_CHILD_LEVEL = 3,//孩子
    DETAIL = 4//编辑
}
export interface IDictParsms {
    branch?: string,
    name?: string,
    enable?: number | string
}
export interface IDictDetail {
    "note"?: string,
    "ver"?: number,
    "code"?: string,
    "pcode"?: string | null,
    "children"?: IDictDetail[] | null,
    "enable"?: number,
    "name"?: string,
    "branch"?: string,
    "value"?: string,
    "key"?: string,
    "title"?: string,
    [key: string]: any,  
}
export interface IDictInsert {
    "sourceApp"?: string,
    "code"?: string,
    "branch"?: string,
    "name"?: string,
    "value"?: null | string,
    "pcode"?: null | string,
    "note"?: string,
    "enable"?:boolean|number
}
export interface IDictUpdata {
    "sourceApp"?: string,
    "code"?: string,
    "branch"?: string,
    "value"?: string
}
export interface IDictRemove {
    "sourceApp": string,
    "code"?: string,
    "branch"?: string,
    [key: string]: any,  

}
export interface IDictDisable {
    "sourceApp": string,
    "code": string,
    "branch": string,
}
export interface IDictSearch extends IDictParsms, ICmSearchPageFields {

}